/*
    Custom Gift with Purchase implementation for Vissla

    Date: September 2023
    Author: Michelle Retzlaff
    Website: https://www.mermaidedevs.com

 */

function clearGWPCart() {
    CartJS.clear()
    CartJS.clearAttributes()
}


async function getQualifyingCartValue(cart, rule) {
    if (rule.collection_handle) {
        var collectionProducts = await getCollectionProductData(rule.collection_handle)
        var cartValue = 0
        cart.items.forEach(function (item) {
            if (collectionProducts.find(product => product.id == item.product_id)) {
                cartValue += item.quantity * item.price
            }
        })
        return cartValue / 100
    } else {
        return cart.total_price / 100
    }

}

async function getCollectionProductData(collectionHandle) {
    var response = await $.ajax({
        url: '/collections/' + collectionHandle + '/products.json',
        dataType: 'json',
    });
    return response.products
}


async function checkRule(cart, rule) {
    const gwpCartAttribute = 'gwp-product-added' + rule.product; // store the variant of the added item here if the gift has been added
    const gwpCartAttributeSelection = 'gwp_product_selection'; // attribute that the product needs to be offered for variant selection
    var giftAdded = CartJS.getAttribute(gwpCartAttribute, false) //  we will store the variant id here
    var giftSelection = CartJS.getAttribute(gwpCartAttributeSelection, '')

    var cartValue = await getQualifyingCartValue(cart, rule)
    var rulesApplies = ruleApplies(cart, cartValue, rule)
    // console.log('cart value', cartValue)
    // if (cartValue >= rule.order_value) {
    if (rulesApplies) {
        // rule applies
        if (!giftAdded) {
            if (rule.has_only_default_variant) {
                // simple product without variant: add it to the cart and set the cart attribute
                CartJS.addItem(rule.first_variant, 1, {}, {
                    "success": function (data, textStatus, jqXHR) {
                        CartJS.setAttribute(gwpCartAttribute, rule.first_variant)
                        document.dispatchEvent(new CustomEvent('cart:build'));
                    },
                    "error": function (jqXHR, textStatus, errorThrown) {
                        console.log('error adding gift')
                    }
                });
            } else {
                // products with variants - set the attribute that it needs to be added
                if (!giftSelection.includes(rule.product_handle)) {
                    CartJS.setAttribute(gwpCartAttributeSelection, giftSelection + rule.product_handle + ',', {
                        "success": function () {
                            document.dispatchEvent(new CustomEvent('cart:build'));
                        }
                    })
                }
            }
        }

    } else {
        // rule doesn't apply (anymore) check if the gift needs to be removed
        if (giftAdded) {
            var giftVariantId = CartJS.getAttribute(gwpCartAttribute, false)
            if (giftVariantId) {
                CartJS.removeItemById(parseInt(giftVariantId), {
                    "success": function (data, textStatus, jqXHR) {
                        CartJS.setAttribute(gwpCartAttribute, null)
                        // remove the selection attribute
                        if (giftSelection.includes(rule.product_handle)) {
                            CartJS.setAttribute(gwpCartAttributeSelection, giftSelection.replace(rule.product_handle + ',', ''))
                        }
                        document.dispatchEvent(new CustomEvent('cart:build'));
                    },
                    "error": function (jqXHR, textStatus, errorThrown) {
                        console.log('error removing gift')
                    }
                });
            }

        } else {
            // remove the selection attribute
            if (giftSelection.includes(rule.product_handle.toString())) {
                CartJS.setAttribute(gwpCartAttributeSelection, giftSelection.replace(rule.product_handle + ',', ''),
                    {
                        "success": function () {
                            document.dispatchEvent(new CustomEvent('cart:build'));
                        }
                    })
            }
        }

    }

}

async function checkAndApplyGWPRules(cart) {
    for (const rule of gwpRules) {
        if (rule.product) {
            await checkRule(cart, rule)
        }
    } // end foreach

    // could emit a custom event here
    document.dispatchEvent(new CustomEvent('vissla-gwp:rules-checked'));
}

function ruleApplies(cart, cartValue, rule) {
    return (rule.order_value > 0 && cartValue >= rule.order_value) || (rule.order_value == 0 && cartValue > 0)
}

async function buildProgressBars(cart) {
    var progressBar = document.createElement('div');

    for (const rule of gwpRules) {

        var cartValue = await getQualifyingCartValue(cart, rule)
        var rulesApplies = ruleApplies(cart, cartValue, rule)
        if (!rulesApplies) {

            var progressElementContainer = document.createElement('div');
            progressElementContainer.setAttribute('class', 'gwp-progress-bar-container')

            var progressElementContainerLabel = document.createElement('div');
            progressElementContainerLabel.setAttribute('class', 'gwp-progress-bar-label')

            // progress bar
            var progressElement = document.createElement('progress');
            progressElement.setAttribute('max', rule.order_value);  // Maximum value
            progressElement.setAttribute('value', cartValue); // Current progress value

            // rule label / incentive text
            var incentive = ''
            if (rule.custom_text) {
                incentive = rule.custom_text
            } else {
                if (rule.collection_handle) {
                    incentive += `Spend $${rule.order_value} on ${rule.collection_title}`
                } else {
                    incentive += `Spend $${rule.order_value}`
                }
                if (rule.product) {
                    incentive += ` for a free ${rule.product_title}`
                } else if (rule.free_shipping) {
                    incentive += ` for free shipping`
                }
            }

            var progressLabel = document.createElement('span');
            progressLabel.innerHTML = incentive

            // amount away
            var progressLabelDiff = document.createElement('span');
            progressLabelDiff.setAttribute('class', 'text-right amount-away')
            if (rule.order_value > 0) {
                progressLabelDiff.innerHTML = `<strong>$${Math.round(rule.order_value - cartValue)}</strong> away`
            }

            progressElementContainerLabel.appendChild(progressLabel);
            progressElementContainerLabel.appendChild(progressLabelDiff);

            progressElementContainer.appendChild(progressElementContainerLabel);

            progressElementContainer.appendChild(progressElement);
            progressBar.appendChild(progressElementContainer);
        }

    } // end for

    // add/replace the progress HTML element if applicable
    document.getElementById('gwp-progress-bar').innerHTML = progressBar.innerHTML;
}

function getCartAndBuildProgressBars() {
    $.ajax({
        url: '/cart.js',
        dataType: 'json',
        success: function (cart) {
            // console.log(cart);
            buildProgressBars(cart)
        },
        error: function (error) {
            console.error('Error fetching the cart:', error);
        }
    });
}

async function getCartAndCheckGwpRules() {
    var cart = await $.ajax({
        url: '/cart.js',
        dataType: 'json'
    });
    await checkAndApplyGWPRules(cart)
}

function findVariantByOptions(product, selectedOptions) {
    return product.variants.find(variant => {
        return variant.options.every((value, index) => value === selectedOptions[index]);
    });
}

function getVariantFromOptions(product) {
    var selectorStr = `#gwp-select-${product.id} :checked`
    const selectedOptions = Array.from(document.querySelectorAll(selectorStr)).map(select => select.value);
    const matchingVariant = findVariantByOptions(product, selectedOptions);

    if (matchingVariant) return matchingVariant.id
    else return null
}

function handleAddGwp(e) {
    e.preventDefault()
    var product = e.target.dataset.product
    var productJson = JSON.parse(product)
    var variantId = getVariantFromOptions(productJson)

    const gwpCartAttribute = 'gwp-product-added' + productJson.id; // store the variant of the added item here if the gift has been added
    const gwpCartAttributeSelection = 'gwp_product_selection'; // attribute that the product needs to be offered for variant selection
    var giftSelection = CartJS.getAttribute(gwpCartAttributeSelection, '')

    // add to cart & set cart attributes
    CartJS.addItem(variantId, 1, {}, {
        "success": function (data, textStatus, jqXHR) {
            CartJS.setAttribute(gwpCartAttribute, variantId)

            // remove the selection attribute
            if (giftSelection.includes(productJson.handle)) {
                CartJS.setAttribute(gwpCartAttributeSelection, giftSelection.replace(productJson.handle + ',', ''),
                    {
                        "success": function (data, textStatus, jqXHR) {
                            document.dispatchEvent(new CustomEvent('cart:build'))
                        }
                    })
            }
        },
        "error": function (jqXHR, textStatus, errorThrown) {
            console.log('error adding gift')
        }
    });

}

jQuery(function () {

    document.addEventListener('ajaxProduct:added', function (evt) {
        getCartAndCheckGwpRules()
    });

    const cartQtyEvents = ['cart:quantity cartundefined', 'cart:quantity cart', 'cart:quantity.cart-undefined', 'cart:updated'];
    cartQtyEvents.forEach(event => {
        document.addEventListener(event, function (evt) {
            getCartAndCheckGwpRules()
        });
    });

    // add the progress bar initially and via event listener
    getCartAndBuildProgressBars()
    document.addEventListener('vissla-gwp:rules-checked', function (evt) {
        getCartAndBuildProgressBars()
    })

})